import { BusinessSubscriptionPricingViewModel } from './business-subscription-pricing';

export class BusinessSubscriptionViewModel {
    public pricingPlans: BusinessSubscriptionPricingViewModel[] = [];

    constructor(pricingPlans?: BusinessSubscriptionPricingViewModel[]) {
        if (pricingPlans) {
            this.pricingPlans = pricingPlans;
        }
    }

    get pricings(): BusinessSubscriptionPricingViewModel[] {
        return this.pricingPlans.slice(0, this.pricingPlans.length).sort((a, b) => (a.level > b.level ? 1 : -1));
    }

    get numberOfPricingPlans(): number {
        return this.pricingPlans.length;
    }

    get indexOfCurrentSubscription(): number {
        return this.pricingPlans.findIndex(p => p.isBusinessSubscribedTo);
    }
}
